import axios from "axios";
import React from "react";
import { AmplitudeContext } from "../../../universal/helpers/amplitude/context";

const ALLOWED_HOSTS = [
  "localhost",
  "dd.live.eismedi.com",
  "myhealthdecisions.com",
  "www.myhealthdecisions.com",
  "preview.myhealthdecisions.com",
  "www.preview.myhealthdecisions.com",
  "decisions.dynamed.com",
  "www.decisions.dynamed.com",
  "preview.decisions.dynamed.com",
  "www.preview.decisions.dynamed.com",
  "dd-hippocrates-ui.preview.clinical-live.cloud",
  "mhd.devqa.eismedi.com",
  "mhd.live.eismedi.com",
  "healthdecisions.devqa.eismedi.com",
  "dd.devqa.eismedi.com"
];

const getAmplitudeExperimentVariants = async (
  hostname,
  sessionNumber,
  customer_id
) => {
  try {
    if (!ALLOWED_HOSTS.includes(hostname)) {
      console.warn(`Blocked potentially unsafe hostname: ${hostname}`);
      return {};
    }

    const baseUrl =
      hostname === "localhost"
        ? "http://localhost:3030"
        : `https://${hostname}`;
    const { data } = await axios.get(`${baseUrl}/experimentVariants`, {
      headers: {
        "cache-control": "no-cache",
        "x-should-proxy-api": true
      },
      params: {
        customer_id,
        "session-number": sessionNumber,
        location: hostname
      }
    });
    return data;
  } catch (err) {
    console.error("Unable to retrieve amplitude experiments");
    console.error(err);
    return {};
  }
};

export default async function configureAmplitude(
  hostname,
  sessionNumber,
  customerId
) {
  const variants = await getAmplitudeExperimentVariants(
    hostname,
    sessionNumber,
    customerId
  );

  return {
    useFeature: (feature, withPayload) => {
      if (withPayload) {
        return variants[feature];
      }

      return !!variants[feature];
    }
  };
}

export const useFeature = feature => {
  const amplitudeUseFeature = React.useContext(AmplitudeContext);
  if (!amplitudeUseFeature) {
    console.warn("Amplitude Experiments provider is not set up");
  }
  return [amplitudeUseFeature && amplitudeUseFeature(feature)];
};

export const useFeaturePayload = feature => {
  const amplitudeUseFeature = React.useContext(AmplitudeContext);
  if (!amplitudeUseFeature) {
    console.warn("Amplitude Experiments provider is not set up");
    return null;
  }
  return amplitudeUseFeature(feature, true);
};

export const FeatureComponent = ({ feature, children }) => {
  const [isEnabled] = useFeature(feature);
  return React.createElement(React.Fragment, null, children(isEnabled));
};
